module.exports = __webpack_public_path__ + "img/s4-1.09d9785d.svg";